import React from 'react';
import './Testimonials.css';

function Testimonials() {
  return (
    <div className="testimonials-container">
      <h2 className="testimonials-title">Women We've Helped</h2>
      <div className="testimonials-grid">
        <div className="testimonial-card">
          <p className="quote">"I thought I was the only one sobbing in the clinic bathroom—until WTF Fertility showed me 30 stories just like mine."</p>
          <p className="author">girlypop • 34 • NYC</p>
        </div>

        <div className="testimonial-card">
          <p className="quote">"The money hacks alone saved us more than our first month of rent."</p>
          <p className="author">girlypop • 30 • Montreal</p>
        </div>

        <div className="testimonial-card">
          <p className="quote">"Finally—answers in plain English, without sifting forums at midnight."</p>
          <p className="author">girlypop • 28 • SF</p>
        </div>
      </div>
    </div>
  );
}

export default Testimonials; 